//#region IMPORT
import React, { useCallback, useEffect, useRef, useState } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import { LEG_BASIC } from './index';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useDelete from '../../../../hooks/useDeleteN';
import { useSave } from '../../../../hooks/useSaveN';
import { setSearchText, setYear } from '../../../../Reducer/SearchReducer';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import { mapParamsBySchema } from '../../../../util';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSave1,
  useSave2,
  useDelete1,
  useDelete2,
} from './LEG_BASIC_QUERY';
import { LEG_BASIC_Schema } from './LEG_BASIC_Schema';
import {
  LegBasicDownloadExcelFromRows,
  LegBasicMergeExcelIntoModalRows,
  LegBasicParseExcelSheetToRows,
} from './LEG_BASIC_Excel';
import ExcelJS from 'exceljs';
import { v4 as uuidv4 } from 'uuid';
import {
  LEG_BASIC_DEFAULT_LAW_NM,
} from './LEG_BASIC_Constants';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'LegalCompliance';

function LEG_BASICF() {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const [lanList, setLanList] = useState([]); // 언어 list(기존 유지)
  const imgRef = useRef(null); //작성자 사인

  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  const [inputs1, setInputs1] = useState({
    halfYear: '상반기', // 상/하반기
    lawNm: LEG_BASIC_DEFAULT_LAW_NM, // 법령명
    evaData1: dayjs().format('YYYY-MM-DD'), //평가기간(시작)
    evaData2: dayjs().format('YYYY-MM-DD'), //평가기간(종료)
  });

  const [lawSelectDialogOpen, setLawSelectDialogOpen] = useState(false);
  const [newLawDialogOpen, setNewLawDialogOpen] = useState(false);
  const [newLawNameInput, setNewLawNameInput] = useState('');
  const [lawSelectRows, setLawSelectRows] = useState([]);
  const [lawSelectLoading, setLawSelectLoading] = useState(false);

  const gridRef1 = useRef(); // 기본정보 - 법규준수평가 결과
  const gridRef2 = useRef(); // 법규준수평가 실시
  const fileInputRefModal2 = useRef(null); // 법규준수평가 실시 엑셀 업로드

  //왼쪽 그리드
  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); //그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); //그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);

  // 모달(법규준수평가 실시)
  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalRowData1, setModalRowData1] = useState([]);
  const [selectedModalRowData1, setSelectedModalRowData1] = useState([]);
  const [changedModalRowData1, setChangedModalRowData1] = useState([]);
  const [deletedModalRowData1, setDeletedModalRowData1] = useState([]);
  const selectedModalRowNosRef1 = useRef(new Set());
  const lastCheckedIndexModalRef1 = useRef(null);
  const currentLawNmRef = useRef(LEG_BASIC_DEFAULT_LAW_NM);

  // QUERY: 삭제/저장/조회 훅 연결
  const delete1 = useDelete1();
  const delete2 = useDelete2();
  const { runAsync: SaveDetailAsync } = useSave1();
  const { runAsync: SaveHeaderAsync } = useSave2();

  const { refetch: Search1 } = useSearch1({
    onSuccess: (processedRows) => {
      setRowData1(
        (processedRows || []).map((row) => ({
          ...row,
          lawNm:
            row.lawNm ??
            row.LAW_NM ??
            row.lwLawNm ??
            row.LW_LAW_NM ??
            LEG_BASIC_DEFAULT_LAW_NM,
        }))
      );
    },
  });
  const { run: Search2 } = useSearch2({
    onSuccess: (processedRows) => {
      setModalRowData1(
        (processedRows || []).map((row) => ({
          ...row,
          lawNm:
            row.lawNm ??
            row.LAW_NM ??
            currentLawNmRef.current ??
            LEG_BASIC_DEFAULT_LAW_NM,
        }))
      );
    },
  });

  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      setLawSelectRows(rows || []);
    },
  });

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  const deleteHandler2 = useDelete({
    gridRef: gridRef2,
    deleteMutation: delete2,
    updateDeleted: setDeletedModalRowData1,
    updateRowData: setModalRowData1,
    deletedRowData: deletedModalRowData1,
    rowData: modalRowData1,
    setChangedRowData: setChangedModalRowData1,
  });
  //#endregion

  // 상태값 리셋 기본정보그리드
  const ResetLogic1 = useCallback(() => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  }, []);

  // 상태값 리셋 법규준수평가 실시그리드
  const ResetLogic2 = useCallback(() => {
    setModalRowData1([]);
    setSelectedModalRowData1([]);
    setChangedModalRowData1([]);
    setDeletedModalRowData1([]);
  }, []);

  const handleRowSelection1 = (rowData, rowIndex) => {
    setSelectedRowData1([rowData]);
  };

  const handleRowSelection2 = (rowData, rowIndex) => {
    setSelectedModalRowData1([rowData]);
  };

  //#region 조회()
  //그리드 조회
  const SearchLogic1 = () => {
    ResetLogic1();
    Search1();
  };

  // 법규준수평가 실시 그리드 조회(_value1: inputs1 값)
  const SearchLogic2 = (_value1) => {
    ResetLogic2();
    const evalHalf = _value1?.halfYear ?? inputs1.halfYear;
    const lawNm = _value1?.lawNm ?? inputs1.lawNm ?? LEG_BASIC_DEFAULT_LAW_NM;
    currentLawNmRef.current = lawNm;
    Search2({ evalHalf, lawNm });
  };

  const ApplyLawSelectionLogic = useCallback(
    (lawNm, { clearForNewLaw = false } = {}) => {
      const nextInputs = {
        ...inputs1,
        lawNm,
      };
      setInputs1(nextInputs);
      setLawSelectDialogOpen(false);
      setNewLawDialogOpen(false);
      setNewLawNameInput('');
      currentLawNmRef.current = lawNm;

      if (clearForNewLaw) {
        ResetLogic2();
        const newRow = {
          newYn: 'Y',
          no: uuidv4(),
          lawNm,
          lwNm: '',
          checkItem: '',
          checkContent: '',
          complianceStatus: '',
          remark: '',
        };
        setModalRowData1([newRow]);
        setChangedModalRowData1([newRow]);
        setModalToggle1(true);
        return;
      }

      SearchLogic2(nextInputs);
      setModalToggle1(true);
    },
    [inputs1, ResetLogic2, SearchLogic2]
  );

  const OpenLawSelectLogic = async () => {
    if (!validateSelection()) return;
    setLawSelectDialogOpen(true);
    setLawSelectLoading(true);
    try {
      await Search3Async({});
    } catch (e) {
      console.error(e);
      setLawSelectRows([]);
      dispatch(
        showSnackbar({
          message: '법령 목록 조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      setLawSelectLoading(false);
    }
  };

  const LawSelectLogic = (option) => {
    if (!option) return;
    if (option.id === 'NEW') {
      setLawSelectDialogOpen(false);
      setNewLawNameInput('');
      setNewLawDialogOpen(true);
      return;
    }
    ApplyLawSelectionLogic(option.name || option.id);
  };

  const NewLawConfirmLogic = () => {
    const name = String(newLawNameInput ?? '').trim();
    if (!name) {
      dispatch(
        showSnackbar({
          message: '법령명을 입력하세요.',
          type: 'warning',
        })
      );
      return;
    }
    ApplyLawSelectionLogic(name, { clearForNewLaw: true });
  };

  const executed = useRef(false);
  useEffect(() => {
    if (executed.current) return;
    if (!searchInfo?.custCd) return;
    executed.current = true;
    // SearchLogic1을 deps로 잡지 않기 위해 효과 내에서 조회 로직을 직접 수행
    ResetLogic1();
    if (!validateSelection()) return;
    Search1();
  }, [searchInfo?.custCd, ResetLogic1, validateSelection, Search1]);

  //#endregion
  //#region 저장
  /** 모달 그리드: 편집 중인 셀 커밋 후, 노드 기준 변경·신규 행 수집(React state 클로저 누락 방지) */
  const GetModalChangedRowsForSave = useCallback(() => {
    const api = gridRef2.current?.api;
    if (!api) return [];
    api.stopEditing(false);
    const rows = [];
    api.forEachNode((node) => {
      const d = node?.data;
      if (!d || d.deleteYn === 'Y') return;
      if (d.editYn === 'Y' || d.newYn === 'Y') rows.push({ ...d });
    });
    return rows;
  }, []);

  // 그리드 저장버튼 클릭 시 함수()
  const SaveLogic1 = async () => {
    try {
      const hasDelete = deletedRowData1.length > 0;
      if (!hasDelete) {
        dispatch(
          showSnackbar({
            message: '삭제할 데이터가 없습니다.',
            type: 'warning',
          })
        );
        return;
      }

      await deleteHandler1.DeleteLogic();
      dispatch(showSnackbar({ message: '삭제되었습니다.', type: 'warning' }));
      SearchLogic1();
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    }
  };

  // 법규준수평가 실시 그리드 저장버튼 클릭 시 함수()
  const { run: Save2 } = useSave({
    menuId: SCREEN_MENU_ID,
    schema: LEG_BASIC_Schema,
    getChangedRows: GetModalChangedRowsForSave,
    getDeletedRows: () => deletedModalRowData1,
    requestDelete: deleteHandler2.DeleteLogic,
    requestSave: async (rows) => {
      // QUERY를 다른 페이지처럼 단순화하기 위해, 저장에 필요한 값은 rows에 포함해서 전달
      const detailRows = (rows || []).map((r) => ({
        ...r,
        evalHalf: inputs1.halfYear,
        lawNm: inputs1.lawNm || LEG_BASIC_DEFAULT_LAW_NM,
      }));

      const headerRows = [
        {
          evalHalf: inputs1.halfYear,
          startDt: inputs1.evaData1,
          endDt: inputs1.evaData2,
          lawNm: inputs1.lawNm || LEG_BASIC_DEFAULT_LAW_NM,
        },
      ];

      const res1 = await SaveDetailAsync(detailRows);
      const res2 = await SaveHeaderAsync(headerRows);

      const d1 = Array.isArray(res1?.data) ? res1.data : [];
      const d2 = Array.isArray(res2?.data) ? res2.data : [];

      return { ...res1, data: [...d1, ...d2] };
    },
    reset: () => {
      setChangedModalRowData1([]);
      setDeletedModalRowData1([]);
    },
    refresh: async () => {
      SearchLogic2(inputs1);
      SearchLogic1();
    },
  });

  const SaveLogic2 = async () => {
    const hasDelete = deletedModalRowData1.length > 0;
    const changedRows = GetModalChangedRowsForSave();
    const hasChange = changedRows.length > 0;

    if (!hasDelete && !hasChange) {
      dispatch(
        showSnackbar({
          message: '수정된 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }
    await Save2();
  };
  //#endregion

  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async () => {
    let headerData = [];
    let tableData = [];

    try {
      if (selectedRowData1.length === 0) {
        dispatch(
          showSnackbar({ message: '항목을 선택하세요.', type: 'warning' })
        );
        return;
      } else if (selectedRowData1.length > 1) {
        dispatch(
          showSnackbar({
            message: '하나의 항목만 인쇄 가능합니다.',
            type: 'warning',
          })
        );
        return;
      }

      // 모달이 열리지 않은 상태에서 인쇄 시도한 경우 대비: 데이터 강제 조회
      if (modalRowData1.length === 0) {
        const inputValue = {
          halfYear:
            selectedRowData1[0].evalHalf ?? selectedRowData1[0].lwBranch,
        };
        const params = mapParamsBySchema(LEG_BASIC_Schema.mapper.search2, {
          evalHalf: inputValue.halfYear,
        });

        const result = await apiRequest(
          'post',
          Global.urls.LegalCompliance.getLegBasicR2,
          params
        );

        const rows = Array.isArray(result?.data) ? result.data : [];
        if (rows.length === 0 || rows?.[0]?.type === 'Error') {
          dispatch(
            showSnackbar({
              message: rows?.[0]?.message || '인쇄할 데이터가 없습니다.',
              type: 'error',
            })
          );
          return;
        }
        tableData = Commons.InsertNumber(rows);
      } else {
        tableData = modalRowData1;
      }

      //await SearchPhoto(userInfo.sign);

      const custNm =
        (searchInfo?.custList || []).find((e) => e.value === searchInfo?.custCd)
          ?.name || '';
      const formatYmd = (v) => {
        if (v == null || v === '') return '';
        const d = dayjs(v);
        return d.isValid() ? d.format('YYYY-MM-DD') : '';
      };
      const lwEvaDate1 = formatYmd(
        selectedRowData1[0].startDt ?? selectedRowData1[0].lwEvaStartDt
      );
      const lwEvaDate2 = formatYmd(
        selectedRowData1[0].endDt ?? selectedRowData1[0].lwEvaEndDt
      );
      const userSign = !imgRef.current
        ? ''
        : imgRef.current.replace(/^data:image\/[a-z]+;base64,/, '');

      // 레포트 호환: camelCase + 기존 대문자 키를 같이 전달
      headerData.push({
        custNm,
        lwEvaDate1,
        lwEvaDate2,
        userSign,
        CUST_NM: custNm,
        LW_EVA_DATE1: lwEvaDate1,
        LW_EVA_DATE2: lwEvaDate2,
        USER_SIGN: userSign,
      });

      // 레포트 호환: 테이블도 camelCase + 기존 대문자 키를 같이 전달
      tableData = (tableData || []).map((r) => ({
        ...r,
        evalId: r.evalId ?? r.EVAL_ID ?? '',
        lwNm: r.lwNm ?? r.LW_NM ?? '',
        checkItem: r.checkItem ?? r.CHECK_ITEM ?? '',
        checkContent: r.checkContent ?? r.CHECK_CONTENT ?? '',
        complianceStatus: r.complianceStatus ?? r.COMPLIANCE_STATUS ?? '',
        remark: r.remark ?? r.REMARK ?? '',
        EVAL_ID: r.EVAL_ID ?? r.evalId ?? '',
        LW_NM: r.LW_NM ?? r.lwNm ?? '',
        CHECK_ITEM: r.CHECK_ITEM ?? r.checkItem ?? '',
        CHECK_CONTENT: r.CHECK_CONTENT ?? r.checkContent ?? '',
        COMPLIANCE_STATUS: r.COMPLIANCE_STATUS ?? r.complianceStatus ?? '',
        REMARK: r.REMARK ?? r.remark ?? '',
      }));

      const printData = {
        FileName: 'LEG_BASIC',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      const response = await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      );

      const blobUrl = URL.createObjectURL(response.data);
      window.open(blobUrl, '_blank'); // 새 탭에서 열기
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };
  //사진 가져오기
  const SearchPhoto = async (_path) => {
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.ftpResponse,
        {
          value1: Commons.EncryptAES(_path),
        }
      );

      const data = result?.data;
      if (data && data !== 'Error') {
        imgRef.current = `data:image/png;base64,${data}`;
      }
    } catch (e) {
      console.log(e);
    }
  };

  //법규준수평가 실시 이동 버튼 클릭 시 (_data: 그리드 Row Data)
  const PopupClickEvent1 = async (_data) => {
    const nextInputs = {
      halfYear: _data?.halfYear ?? _data?.evalHalf ?? inputs1.halfYear,
      lawNm:
        _data?.lawNm ??
        _data?.LAW_NM ??
        _data?.lwLawNm ??
        inputs1.lawNm ??
        LEG_BASIC_DEFAULT_LAW_NM,
      evaData1: _data?.evaData1 ?? _data?.startDt ?? inputs1.evaData1,
      evaData2: _data?.evaData2 ?? _data?.endDt ?? inputs1.evaData2,
    };
    setInputs1((prev) => ({ ...prev, ...nextInputs }));
    await SearchLogic2(nextInputs);
    setModalToggle1(true);
  };

  const ExcelDownload2 = async () => {
    try {
      dispatch(showLoading());
      await LegBasicDownloadExcelFromRows(modalRowData1);
      dispatch(
        showSnackbar({
          message: '엑셀 다운로드가 완료되었습니다.',
          type: 'success',
        })
      );
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e?.message || '엑셀 다운로드 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  const ExcelUpload2 = async (file) => {
    try {
      dispatch(showLoading());
      const arrayBuffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '엑셀 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        return;
      }

      const parsed = LegBasicParseExcelSheetToRows(worksheet);
      if (parsed.error === 'HEADER_LW_NM') {
        dispatch(
          showSnackbar({
            message:
              '엑셀에「법규명」열이 있는 데이터 헤더 행이 있어야 합니다. 다운로드 양식을 사용해 주세요.',
            type: 'warning',
          })
        );
        return;
      }

      if (!parsed.rows?.length) {
        dispatch(
          showSnackbar({
            message: '읽을 수 있는 데이터가 없습니다.',
            type: 'warning',
          })
        );
        return;
      }

      const merged = LegBasicMergeExcelIntoModalRows(
        modalRowData1,
        parsed.rows
      );
      setModalRowData1(merged);
      const saveTargetCount = merged.filter(
        (r) => r && r.deleteYn !== 'Y' && (r.editYn === 'Y' || r.newYn === 'Y')
      ).length;
      dispatch(
        showSnackbar({
          message: `엑셀 반영 완료. 저장 대상 ${saveTargetCount}건(변경·신규만). [저장]으로 서버에 반영하세요.`,
          type: 'success',
        })
      );
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e?.message || '엑셀 업로드 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };
  //#endregion

  return (
    <div className="wrap">
      <LEG_BASIC
        userInfo={userInfo}
        lanList={lanList}
        setLanList={setLanList}
        searchInfo={searchInfo}
        searchYear={searchInfo?.year}
        setSearchYear={(y) => dispatch(setYear(y))}
        setSearchText={(t) => dispatch(setSearchText(t))}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        inputs1={inputs1}
        setInputs1={setInputs1}
        gridRef1={gridRef1}
        gridRef2={gridRef2}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        modalRowData1={modalRowData1}
        setModalRowData1={setModalRowData1}
        selectedModalRowData1={selectedModalRowData1}
        setSelectedModalRowData1={setSelectedModalRowData1}
        changedModalRowData1={changedModalRowData1}
        setChangedModalRowData1={setChangedModalRowData1}
        deletedModalRowData1={deletedModalRowData1}
        setDeletedModalRowData1={setDeletedModalRowData1}
        selectedModalRowNosRef1={selectedModalRowNosRef1}
        lastCheckedIndexModalRef1={lastCheckedIndexModalRef1}
        // 함수
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        SearchLogic1={SearchLogic1}
        SearchLogic2={SearchLogic2}
        SaveLogic1={SaveLogic1}
        SaveLogic2={SaveLogic2}
        PrintLogic1={PrintLogic1}
        handleRowSelection1={handleRowSelection1}
        handleRowSelection2={handleRowSelection2}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        RestoreRow1={deleteHandler1.RestoreRow}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        MarkedForDeletion2={deleteHandler2.MarkedForDeletion}
        RestoreRow2={deleteHandler2.RestoreRow}
        DeleteNewRow2={deleteHandler2.DeleteNewRow}
        PopupClickEvent1={PopupClickEvent1}
        OpenLawSelectLogic={OpenLawSelectLogic}
        lawSelectDialogOpen={lawSelectDialogOpen}
        setLawSelectDialogOpen={setLawSelectDialogOpen}
        lawSelectRows={lawSelectRows}
        lawSelectLoading={lawSelectLoading}
        LawSelectLogic={LawSelectLogic}
        newLawDialogOpen={newLawDialogOpen}
        setNewLawDialogOpen={setNewLawDialogOpen}
        newLawNameInput={newLawNameInput}
        setNewLawNameInput={setNewLawNameInput}
        NewLawConfirmLogic={NewLawConfirmLogic}
        fileInputRefModal2={fileInputRefModal2}
        ExcelUpload2={ExcelUpload2}
        ExcelDownload2={ExcelDownload2}
      />
    </div>
  );
}

export default LEG_BASICF;
